import Abstract from './abstract';
import $ from 'jquery';

const
  CONTAINER         = '[data-voc-pw-news-left]',
  ONE_NEWS_MSG      = '[data-voc-pw-one-news]',
  N_NEWS_MSG        = '[data-voc-pw-n-news]',
  REMAINING_NEWS    = [3, 2, 1]
;


class NLeftContent extends Abstract {
  constructor() {
    super(CONTAINER, ...arguments);
    this.priority   = -1;
    this.final      = true;
  }

  show() {
    const maxValue = parseInt(this.config.max), countValue = parseInt(this.config.count);
    const isExtra = this.config.isExtra === 'true';
    const isViewed = this.config.viewed === 'true';
    const remainingValue = maxValue - countValue, steps = this._getDaysToAlert();

    if((countValue > 0 && remainingValue > 0) && !isExtra && steps.indexOf(remainingValue) !== -1 && !isViewed) {
      if (remainingValue > 1) {
        $(N_NEWS_MSG, this.container$).find("span:first").html(remainingValue);
        $(N_NEWS_MSG, this.container$).show();
      } else {
        $(ONE_NEWS_MSG, this.container$).show();
      }

      super.show();
      return true;
    }

    return false;
  }

  _getDaysToAlert() {
    if(this.config.daysToAlertSteps) {
      try {
        const parseValues = JSON.parse(this.config.daysToAlertSteps);

        if(parseValues.default === true) {
          return REMAINING_NEWS;
        }

        return Object.keys(parseValues).map(item => parseInt(item));
      } catch (e) {
        return [];
      }
    }

    return REMAINING_NEWS;
  }
}

export default NLeftContent;



// WEBPACK FOOTER //
// ./src/alerts/n-left-content.js